export const GET_SUPPORTED_FILE_FORMATS_URL = 'adminSettings/lab-resource-allowed-extensions/';
export const GET_MAX_SIZE_FOR_FILE = 'adminSettings/max-upload-file-size/';
export const GET_FILE_UPLOAD_URL = 'resource/';
export const GET_FILE_UPLOAD_DELETE_URL = 'resource/';
export const FILE_UPLOAD_GENERAL = 'video-catalog-thumbnail/';
export const FILE_UPLOAD_LABS = 'lab-icon/';
export const UPLOAD_RESOURCE_URL = 'resource/'